exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\r\n  position: relative;\r\n  display: inline-block;\r\n  width: 2.5rem;\r\n  height: 2.5rem;\r\n}\r\n\r\n.avatar {\r\n  display: block;\r\n  width: 100%;\r\n  height: 100%;\r\n  border-radius: 50%;\r\n  background-size: cover;\r\n  background-position: center center;\r\n  background-repeat: no-repeat;\r\n}\r\n\r\n.avatar--link {\r\n  cursor: pointer;\r\n}\r\n\r\n.spinner {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/shared/avatar/avatar.component.css
// module id = ../../../../../src/app/shared/avatar/avatar.component.css
// module chunks = 4